function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#2196F3",
  d: "M0 2.4C0 1.075 1.075 0 2.4 0h16.8c1.325 0 2.4 1.075 2.4 2.4v16.8c0 1.325-1.075 2.4-2.4 2.4H2.4c-1.325 0-2.4-1.075-2.4-2.4V2.4z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M12.6 6.6h4.2v1.2h-4.2V6.6zm-3.293 3.857c.351-.171 1.142-.56 1.142-1.714 0-2.17-2.371-2.142-2.81-2.142H3.6V15h4.215c.351-.001 2.985-.1 2.985-2.402 0-1.485-.966-1.97-1.493-2.142zM5.4 8.057h1.757c.175 0 1.317.062 1.317.943 0 .88-.878 1.028-1.141 1.028H5.4V8.057zm2.002 5.486h-2.02v-2.314h2.02c.438 0 1.404.142 1.404 1.2 0 1.057-1.23 1.114-1.404 1.114zm8.46-.106c-.278.173-.557.262-.929.262-1.395 0-1.673-1.177-1.673-1.698H18c0-.522 0-.907-.093-1.342-.094-.435-.729-2.259-3.067-2.259-3.267 0-3.44 2.867-3.44 3.3 0 .434.094.956.28 1.303.186.434.372.782.65 1.041.279.261.65.52 1.022.694.465.175.93.262 1.395.262.743 0 1.394-.173 1.952-.52.558-.348.93-.87 1.208-1.564h-1.58c-.093.174-.186.346-.464.521zm-1.022-3.82c.911 0 1.301.954 1.394 1.388H13.26c0-.086.223-1.389 1.58-1.389z"
}));

var SvgIconBehance = function SvgIconBehance(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconBehance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-behance.18eaa882.svg";
export { ForwardRef as ReactComponent };